<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 9</h1>
          <div class="text-left">
              <p>RAF Museum Duxford</p>
              <a href="/uk/09RAF1.jpeg"><img alt="RAF Museum Duxford" class="uitk-image-media" src="/uk/09RAF1.jpeg" style="width: 17%; height: auto;"></a>
              <a href="/uk/09RAF2.jpeg"><img alt="RAF Museum Duxford" class="uitk-image-media" src="/uk/09RAF2.jpeg" style="width: 17%; height: auto;"></a>
              <a href="/uk/09RAF3.jpeg"><img alt="RAF Museum Duxford" class="uitk-image-media" src="/uk/09RAF3.jpeg" style="width: 17%; height: auto;"></a>
              <a href="/uk/09RAF4.jpeg"><img alt="RAF Museum Duxford" class="uitk-image-media" src="/uk/09RAF4.jpeg" style="width: 17%; height: auto;"></a>
              <p>Sunday Roast</p>
              <a href="/uk/09Plough.jpeg"><img alt="Duxford Synday Lunch" class="uitk-image-media" src="/uk/09Plough.jpeg" style="width: 17%; height: auto;"></a>
          </div>      
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
      ////
    }
  }
  </script>